// store/thunks/auth/resendEmailCodeThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { VerificationDTO } from '@/types/dtos.types';

export const resendEmailCodeThunk = createAdminAsyncThunk<
  VerificationDTO,
  undefined,
  { rejectValue: { message: string } }
>(
  'auth/resendEmailCode',
  async(_, { extra: { authService }, rejectWithValue }) => {

    try {
      return await authService.resendEmailCode();
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to resend email code';
      return rejectWithValue({ message });
    }
  }
);

